export const selectStudyPlan = (state) => state.studyPlan;
export const selectStudyPlanDays = (state) => state.studyPlan.days;
export const selectStudyPlanEnrichedDays = (state) => state.studyPlan.enrichedDays;
export const selectStudyPlanCompletedLessons = (state) => state.studyPlan.completedLessons;
export const selectStudyPlanTruncated = (state) => state.studyPlan.truncated;
export const selectStudyPlanDaysCount = (state) => state.studyPlan.totalStudyDaysCount;
export const selectStudyPlanCompletionDate = (state) => {
  const iso = state.studyPlan.completionDate;
  if (!iso) return null;
  const [year, month, day] = iso.split("-").map(Number);
  return new Date(year, month - 1, day);
};
